module.exports = __webpack_public_path__ + "static/media/ic_checked.eff8b130.svg";